import generateJWT from "./GiveawaySignUpJWT";
import {postApiGiveawaySignupJWT} from "../../api/cms";

export const generateRequestData = async (requestData:any, allGiveawaysIds:any) => {

  // Declares array to store each response intent.
  let arrayResponse: any[];
  arrayResponse = [];

  await Promise.all(
    allGiveawaysIds.map(async (item: any, i: number) => {
      let currentGiveawayId = item.giveawayId;
      let currentGiveawayOptIn = item.giveawayOptIn;

      // Spread method to create/update request values.
      let currentRequestData = {...requestData}
      currentRequestData.giveawayId = currentGiveawayId;
      currentRequestData.formFields.giveawayId = currentGiveawayId;
      currentRequestData.formFields.giveawayOptIn = currentGiveawayOptIn;

      // Declares variables to set status from current request.
      let sendingRequestValue: boolean;
      let doRedirectValue;

      try {
        const jwt = await generateJWT(currentRequestData);
        const response1 = await postApiGiveawaySignupJWT(jwt, currentRequestData['giveawayId']);
        sendingRequestValue = true;

        if (response1.success) {
          doRedirectValue = true;
        }
        // console.log(JSON.stringify(res));
      }
      catch (e) {
        // console.log(JSON.stringify(e));
      }
      finally {
        sendingRequestValue = false;
      }

      // Store in a main array values from current request.
      arrayResponse.push({
        giveawayId:  currentRequestData.giveawayId,
        sendingRequest: sendingRequestValue,
        doRedirect: doRedirectValue,
      });
    })
  );

  return arrayResponse;

};

export default generateRequestData;
